import { lazy } from 'react';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import ListAltIcon from '@mui/icons-material/ListAlt';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import QuestionMarkRoundedIcon from '@mui/icons-material/QuestionMarkRounded';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import { withSuspense } from '@senderra/shared/hocs';
import { i18n } from '@senderra/translations';
import { Navigate } from 'react-router-dom';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';

const HomePage = withSuspense(lazy(() => import('./home')));
const ProfilePage = withSuspense(lazy(() => import('./profile')));
const TenantPage = withSuspense(lazy(() => import('./tenant')));
const UserManagement = withSuspense(lazy(() => import('./user-management')));
const Referral = withSuspense(lazy(() => import('./reports/referral')));
const Refill = withSuspense(lazy(() => import('./reports/refill')));
const Dispense = withSuspense(lazy(() => import('./reports/dispense')));
const Preferences = withSuspense(lazy(() => import('./preferences')));
const UsageTracker = withSuspense(lazy(() => import('./usage-tracker')));
const Faq = withSuspense(lazy(() => import('./faq')));

export const pages = {
    frm: {
        home: { url: '/', component: HomePage },
        reportsReferral: { url: '/reports/referral', component: Referral },
        reportsRefill: { url: '/reports/refill', component: Refill },
        reportsDispense: { url: '/reports/dispense', component: Dispense },
        faq: { url: '/faq', component: Faq },
        profile: { url: '/profile', component: ProfilePage },
        preferences: { url: '/preferences', component: Preferences },
    },
    tenant: {
        home: { url: '/', component: () => <Navigate to='/manufacturer-profile' replace /> },
        user: { url: '/user-management', component: UserManagement },
        faq: { url: '/faq', component: Faq },
        tracker: { url: '/usage-tracker', component: UsageTracker },
        profile: { url: '/profile', component: ProfilePage },
        tenantProfile: { url: '/manufacturer-profile', component: TenantPage },
    },
    default: {
        home: { url: '/', component: () => 'There is nothing to show. Please get in touch with support.' },
    },
} as const;

export const reports = {
    referral: {
        icon: PersonAddAltOutlinedIcon,
        title: i18n.t('referral-page-title'),
        description: i18n.t('referral-page-descr'),
        url: pages.frm.reportsReferral.url,
    },
    refill: {
        icon: AssignmentOutlinedIcon,
        title: i18n.t('refill-page-title'),
        description: i18n.t('refill-page-descr'),
        url: pages.frm.reportsRefill.url,
    },
    dispense: {
        icon: MedicalServicesOutlinedIcon,
        title: i18n.t('dispense-page-title'),
        description: i18n.t('dispense-page-descr'),
        url: pages.frm.reportsDispense.url,
    },
};

export const navPageDefault = [
    {
        title: 'Home',
        icon: HomeOutlinedIcon,
        ...pages.default.home,
    },
];

export const navPagesFRMAdmin = [
    {
        title: i18n.t('home'),
        icon: HomeOutlinedIcon,
        ...pages.frm.home,
    },
    {
        title: i18n.t('reports'),
        icon: ListAltIcon,
        pages: [
            {
                title: reports.referral.title,
                ...pages.frm.reportsReferral,
            },
            {
                title: reports.refill.title,
                ...pages.frm.reportsRefill,
            },
            {
                title: reports.dispense.title,
                ...pages.frm.reportsDispense,
            },
        ],
    },
    {
        title: i18n.t('faq'),
        icon: QuestionMarkRoundedIcon,
        ...pages.frm.faq,
    },
    {
        title: i18n.t('preferences'),
        icon: BookmarkBorderOutlinedIcon,
        ...pages.frm.preferences,
    },
];

export const navPagesTenantAdmin = [
    {
        title: i18n.t('tenant-profile'),
        icon: PersonOutlinedIcon,
        ...pages.tenant.tenantProfile,
    },
    {
        title: i18n.t('user-management'),
        icon: ManageAccountsOutlinedIcon,
        ...pages.tenant.user,
    },
    {
        title: i18n.t('faq'),
        icon: QuestionMarkRoundedIcon,
        ...pages.tenant.faq,
    },
    {
        title: i18n.t('usage-tracker'),
        icon: AnalyticsOutlinedIcon,
        ...pages.tenant.tracker,
    },
];
